import { useMemo, useState } from 'react';

import { ARCHIVE, UPCOMING } from '@/data/events';
import { useI18n } from '@/providers/i18n';

import ArchiveCard from './components/ArchiveCard';
import EventRow from './components/EventRow';
import styles from './EventsPage.module.css';

export default function EventsPage() {
  const { t, lang } = useI18n();
  const [year, setYear] = useState<string>('ALL');

  const years = useMemo<string[]>(() => {
    const ys = Array.from(
      new Set(ARCHIVE.map((e) => String(new Date(e.date).getFullYear()))),
    ).sort((a, b) => Number(b) - Number(a));
    return ['ALL', ...ys];
  }, []);

  const archiveList = useMemo(
    () =>
      year === 'ALL'
        ? ARCHIVE
        : ARCHIVE.filter((e) => String(new Date(e.date).getFullYear()) === year),
    [year],
  );

  return (
    <section>
      <header className="page-h">
        <div>
          <span className="nano">/ EVENTS / UPCOMING</span>
          <h1>{t('label.upcoming')}</h1>
        </div>
        <span className="meta">{UPCOMING.length} TRANSMISSIONS QUEUED</span>
      </header>

      <div style={{ marginTop: 12 }}>
        {UPCOMING.map((e) => (
          <EventRow key={e.id} event={e} />
        ))}
      </div>

      <section className={styles.archiveSection}>
        <header className="page-h">
          <div>
            <span className="nano">/ EVENTS / ARCHIVE</span>
            <h2>{t('label.archive')}</h2>
          </div>
          <span className="meta">{ARCHIVE.length} ENTRIES · 2018 → 2024</span>
        </header>

        <div className="filters">
          {years.map((y) => (
            <button
              key={y}
              type="button"
              className={'filter-btn' + (year === y ? ' active' : '')}
              onClick={() => setYear(y)}
            >
              {y === 'ALL' ? t('label.all') : y}
            </button>
          ))}
        </div>

        <div className={styles.archiveGrid}>
          {archiveList.map((e, i) => (
            <ArchiveCard key={e.id} event={e} lang={lang} index={i} />
          ))}
        </div>
      </section>
    </section>
  );
}
